import {
  FilterableSinglePicker as SharedFilterableSinglePicker,
  FilterableSinglePickerProps as SharedFilterableSinglePickerProps,
} from "@flaminem/ui-components";

import { useT } from "src/internationalization";

export type FilterableSinglePickerProps<T> = Omit<
  SharedFilterableSinglePickerProps<T>,
  "languageTexts"
>;

export function FilterableSinglePicker<T>(props: FilterableSinglePickerProps<T>) {
  const t = useT();

  return (
    <SharedFilterableSinglePicker
      {...props}
      languageTexts={{
        noOptions: t("general.info.no.options"),
        errorLoadingOptions: t("general.info.error.loading.options"),
        emptySearch: t("general.info.start.typing.to.search"),
      }}
    />
  );
}
